import { render, staticRenderFns } from "./Intelligent.vue?vue&type=template&id=2dc8aefe&scoped=true&"
import script from "./Intelligent.vue?vue&type=script&lang=js&"
export * from "./Intelligent.vue?vue&type=script&lang=js&"
import style0 from "./Intelligent.vue?vue&type=style&index=0&id=2dc8aefe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8aefe",
  null
  
)

export default component.exports